import './box.css'
import './web_component'
import React from 'react'
import { BoxLayoutProps } from './types'

export const Box: React.FC<BoxLayoutProps> = ({ children, ...props }) => <box-l {...props}>{children}</box-l>
